// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".spred-mask {\n  position: absolute;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: rgba(var(--ion-color-dark-rgb), 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
